import playerActions from 'tg-core-redux/lib/modules/player/action';
import responsibleGamingActions from 'tg-core-redux/lib/modules/responsible_gaming/action';

export const interval = payload => dispatch => {
  dispatch({ type: 'INTERVAL_START', payload });
  Promise.all([
    dispatch(responsibleGamingActions.getProductBlocks(payload)),
    dispatch(playerActions.getDisplayPages(payload)),
  ])
    .then(() => dispatch({ type: 'INTERVAL_COMPLETE', payload }))
    .catch(() => dispatch({ type: 'INTERVAL_FAILURE', payload }));
};

export default interval;
